'use client';

import { BookmarkIcon, BookmarkFilledIcon } from '../Icons/Icons';
import { useBookmark } from '@/hooks/useBookmark';
import { useLoginModals } from '@/components/Login/common/LoginModalsManager';

interface BookmarkProps {
  isBookmarkedBool?: boolean | null;
  courseEntryUid?: string;
  lessonEntryUid?: string;
  className?: string;
}

/** Generic bookmark toggle, shared by course and lesson bookmarking (pass `lessonEntryUid` for a lesson). */
export default function Bookmark({
  isBookmarkedBool,
  courseEntryUid,
  lessonEntryUid,
  className,
}: BookmarkProps) {
  const { openLoginModal } = useLoginModals();
  
  const { isBookmarked, toggleBookmark, isLoading } = useBookmark({
    entityType: lessonEntryUid ? 'lesson' : 'course',
    entityUid: lessonEntryUid || courseEntryUid,
    courseUid: courseEntryUid,
    initialBookmarked: isBookmarkedBool ?? false,
    onLoginRequired: openLoginModal,
  });

  return (
    <div 
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleBookmark();
      }} 
      className={`cursor-pointer ${className || ''}`}
    >
      {isBookmarked ? (
        <BookmarkFilledIcon className="text-[var(--Icons-Medium)]" />
      ) : (
        <BookmarkIcon className="text-[var(--Icons-Medium)]" />
      )}
    </div>
  );
}
